import React from 'react'
import styles from './styles.module.scss'

export default function CollectionDetails({ copy }: { copy: string }) {
  return (
    <div className={styles.collectionDetailsWrapper}>
      <p className={styles.collectionDetailsWrapper__text}>{copy}</p>
    </div>
  )
}
